import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { actualMaxPrintColorsSelector, printingProcessDescriptionSelector, productViewsSelector, shouldShowMaxPrintColorsMessageSelector } from '../../../../../../redux/product/product.selectors';
import { DesignUploadPanelComponent } from './design-upload-panel';
const mapStateToProps = createStructuredSelector({
  maxPrintColors: actualMaxPrintColorsSelector,
  shouldShowMaxPrintColorsMessage: shouldShowMaxPrintColorsMessageSelector,
  printingProcessDescription: printingProcessDescriptionSelector,
  productViews: productViewsSelector
});
export const DesignUploadPanel = connect(mapStateToProps)(DesignUploadPanelComponent);